document.addEventListener('DOMContentLoaded', () => {
  const UPSELL_OFFERS = {
   'upsell-hibiscus-bliss': {
  id: 47314032230630,
  title: 'Dry Bag',
  originalPrice: '$89.00',
  salePrice: '$75.65',
      image: 'https://cdn.shopify.com/s/files/1/0655/1198/1286/files/0J0A7530.jpg?v=1761297910',
      message: 'Your beach day essentials. Pair your style with our dry bag! Available at a special add-on price'
    },


    'upsell-coral-sands': {
  title: 'Cap',
  originalPrice: '$39.00',
  salePrice: '$33.15',
  message: 'Complete the look with our cap. Enjoy a special price when added to your set',
  options: [
    {
      label: 'Cocoa',
      id: 45927755514086,
      image: 'https://cdn.shopify.com/s/files/1/0655/1198/1286/files/DSC05537.jpg?v=1753091238'
    },
    {
      label: 'Beige',
      id: 46731744379110,
      image: 'https://cdn.shopify.com/s/files/1/0655/1198/1286/files/WhatsApp_Image_2025-12-02_at_12.27.41_1.jpg?v=1764643906'
    }
  ]
},

'upsell-volcanic': {
  title: 'Free Cap',
  originalPrice: '$39.00',
  salePrice: 'FREE',
  message: 'Complete the volcanic look. Today only! Get a free cap with your Volcanic set',
  options: [
    {
      label: 'Cocoa',
      id: 45927755514086,
      image: 'https://cdn.shopify.com/s/files/1/0655/1198/1286/files/DSC05537.jpg?v=1753091238'
    },
    {
      label: 'Beige',
      id: 46731744379110,
      image: 'https://cdn.shopify.com/s/files/1/0655/1198/1286/files/WhatsApp_Image_2025-12-02_at_12.27.41_1.jpg?v=1764643906'
    }
  ]
}
  };


  const modal = document.getElementById('salted-upsell-modal');
  const addBtn = document.getElementById('salted-upsell-add');
  const skipBtn = document.getElementById('salted-upsell-skip');
  const closeBtn = document.querySelector('.salted-upsell-close');
  const backdrop = document.querySelector('.salted-upsell-backdrop');
  const optionsWrap = document.getElementById('salted-upsell-options-wrap');
  const optionSelect = document.getElementById('salted-upsell-option');


  const titleEl = document.getElementById('salted-upsell-title');
  const messageEl = document.getElementById('salted-upsell-message');
  const imageEl = document.getElementById('salted-upsell-image');



  if (!modal || !addBtn || !skipBtn || !closeBtn || !optionsWrap || !optionSelect) return;


  function openPopup(offer) {
    window.currentUpsell = offer;


    titleEl.innerText = offer.title;
    messageEl.innerText = offer.message;
    document.getElementById('salted-upsell-original-price').innerText = offer.originalPrice;
document.getElementById('salted-upsell-sale-price').innerText = offer.salePrice;


    optionSelect.onchange = null;


    if (offer.options && offer.options.length > 0) {
      optionsWrap.style.display = 'block';
      optionSelect.innerHTML = '';


      offer.options.forEach((option) => {
        const optionEl = document.createElement('option');
        optionEl.value = option.id;
        optionEl.textContent = option.label;
        optionSelect.appendChild(optionEl);
      });


      imageEl.src = offer.options[0].image;
      imageEl.alt = `${offer.title} ${offer.options[0].label}`;


      optionSelect.onchange = () => {
        const selectedId = Number(optionSelect.value);
        const selectedOption = offer.options.find((option) => option.id === selectedId);


        if (selectedOption && selectedOption.image) {
          imageEl.src = selectedOption.image;
          imageEl.alt = `${offer.title} ${selectedOption.label}`;
        }
      };
    } else {
      optionsWrap.style.display = 'none';
      optionSelect.innerHTML = '';
      imageEl.src = offer.image;
      imageEl.alt = offer.title;
    }


    modal.classList.remove('hidden');
  }


  function closePopup() {
    modal.classList.add('hidden');
    window.currentUpsell = null;
  }


  skipBtn.addEventListener('click', closePopup);
  closeBtn.addEventListener('click', closePopup);
  backdrop.addEventListener('click', closePopup);


  addBtn.addEventListener('click', async () => {
    const offer = window.currentUpsell;
    if (!offer) return;


    const variantId = offer.options && offer.options.length > 0
      ? Number(optionSelect.value)
      : offer.id;


    addBtn.disabled = true;
    addBtn.innerText = 'Adding...';


    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });


      if (!response.ok) {
        throw new Error('Add to cart failed');
      }


      closePopup();


sessionStorage.setItem('saltedOpenCartAfterReload', 'true');
window.location.reload();
    } catch (error) {
      console.error(error);
      alert('Sorry, we could not add this item right now.');
    } finally {
      addBtn.disabled = false;
      addBtn.innerText = 'Add to set';
    }
  });


  document.addEventListener('submit', function(event) {
    const form = event.target;


    if (!form || !form.action || !form.action.includes('/cart/add')) return;


    const tags = window.productTags || [];
    let offer = null;


    tags.forEach((tag) => {
      if (UPSELL_OFFERS[tag]) {
        offer = UPSELL_OFFERS[tag];
      }
    });


    if (offer) {
      setTimeout(() => openPopup(offer), 500);
    }
  });
  if (sessionStorage.getItem('saltedOpenCartAfterReload') === 'true') {
  sessionStorage.removeItem('saltedOpenCartAfterReload');


  setTimeout(() => {
    const cartIcon =
      document.querySelector('a[href="/cart"]') ||
      document.querySelector('[href="/cart"]') ||
      document.querySelector('.header__icon--cart') ||
      document.querySelector('[data-cart-drawer]') ||
      document.querySelector('[data-cart-icon]');


    if (cartIcon) {
      cartIcon.click();
    }
  }, 1000);
}
});
